const host = (env) => {
  const hostList = [
    {
      env: 'local',
      nodeUrl: 'http://localhost:5003',
      mdoUrl: 'http://localhost:5001',
      // nodeUrl: 'https://nodetest.sgsonline.com.cn',
      // mdoUrl: 'https://mallmdotest.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmstest.sgsonline.com.cn',
      portalUrl: 'https://portaltest.sgsonline.com.cn',
      storeUrl: 'https://tictest.sgsonline.com.cn',
      mallUrl: 'https://test.sgsmall.com.cn',
      javaUrl: 'https://gatetest.sgsonline.com.cn',
      domain: 'localhost',
      indUrl: 'https://indtest.sgsonline.com',
      memberUrl: 'https://membertest.sgsonline.com.cn',
      indMemberUrl: 'https://indtest.sgsonline.com.cn/'
    },
    {
      env: 'dev',
      nodeUrl: 'https://nodedev.sgsonline.com.cn',
      mdoUrl: 'https://mallmdodev.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmsdev.sgsonline.com.cn',
      portalUrl: 'https://portaldev.sgsonline.com.cn',
      storeUrl: 'https://ticdev.sgsonline.com.cn',
      mallUrl: 'https://dev.sgsmall.com.cn',
      javaUrl: 'https://gatedev.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://memberdev.sgsonline.com.cn',
      indMemberUrl: 'https://inddev.sgsonline.com.cn/'
    },
    {
      env: 'uat',
      nodeUrl: 'https://nodeuat.sgsonline.com.cn',
      mdoUrl: 'https://mallmdouat.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmsuat.sgsonline.com.cn',
      portalUrl: 'https://portaluat.sgsonline.com.cn',
      storeUrl: 'https://ticuat.sgsonline.com.cn',
      mallUrl: 'https://uat.sgsmall.com.cn',
      javaUrl: 'https://gateuat.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://memberuat.sgsonline.com.cn',
      indMemberUrl: 'https://induat.sgsonline.com.cn/'
    },
    {
      env: 'test',
      nodeUrl: 'https://nodetest.sgsonline.com.cn',
      mdoUrl: 'https://mallmdotest.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmstest.sgsonline.com.cn',
      portalUrl: 'https://portaltest.sgsonline.com.cn',
      storeUrl: 'https://tictest.sgsonline.com.cn',
      mallUrl: 'https://test.sgsmall.com.cn',
      javaUrl: 'https://gatetest.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://indtest.sgsonline.com',
      memberUrl: 'https://membertest.sgsonline.com.cn',
      indMemberUrl: 'https://indtest.sgsonline.com.cn/'
    },
    {
      env: 'prod',
      nodeUrl: 'https://node.sgsonline.com.cn',
      mdoUrl: 'https://mallmdo.sgsonline.com.cn',
      sgsonlineUrl: 'https://www.sgsonline.com.cn',
      portalUrl: 'https://portal.sgsonline.com.cn',
      storeUrl: 'https://store.sgsonline.com.cn',
      mallUrl: 'https://www.sgsmall.com.cn',
      javaUrl: 'https://gate.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://member.sgsonline.com.cn',
      indMemberUrl: 'https://ind.sgsonline.com.cn/'
    },
    {
      env: 'production',
      nodeUrl: 'https://node.sgsonline.com.cn',
      mdoUrl: 'https://mallmdo.sgsonline.com.cn',
      sgsonlineUrl: 'https://www.sgsonline.com.cn',
      portalUrl: 'https://portal.sgsonline.com.cn',
      storeUrl: 'https://store.sgsonline.com.cn',
      mallUrl: 'https://www.sgsmall.com.cn',
      javaUrl: 'https://gate.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://member.sgsonline.com.cn',
      indMemberUrl: 'https://ind.sgsonline.com.cn/'
    },
    {
      env: 'azureproduction',
      nodeUrl: 'https://node.sgsonline.com.cn',
      mdoUrl: 'https://mallmdo.sgsonline.com.cn',
      sgsonlineUrl: 'https://www.sgsonline.com.cn',
      portalUrl: 'https://portal.sgsonline.com.cn',
      storeUrl: 'https://store.sgsonline.com.cn',
      mallUrl: 'https://www.sgsmall.com.cn',
      javaUrl: 'https://gate.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://member.sgsonline.com.cn',
      indMemberUrl: 'https://ind.sgsonline.com.cn/'
    },
    {
      env: 'uatGray',
      nodeUrl: 'https://nodeuatgray.sgsonline.com.cn',
      mdoUrl: 'https://mallmdouatgray.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmsuatgray.sgsonline.com.cn',
      portalUrl: 'https://portaluatgray.sgsonline.com.cn',
      storeUrl: 'https://ticuatgray.sgsonline.com.cn',
      mallUrl: 'https://uatgray.sgsmall.com.cn',
      javaUrl: 'https://gateuat.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      version: 'gray',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://memberuatgray.sgsonline.com.cn',
      indMemberUrl: 'https://induatgray.sgsonline.com.cn/'
    },
    {
      env: 'prodGray',
      nodeUrl: 'https://nodegray.sgsonline.com.cn',
      mdoUrl: 'https://mallmdogray.sgsonline.com.cn',
      sgsonlineUrl: 'https://cmsgray.sgsonline.com.cn',
      portalUrl: 'https://portalgray.sgsonline.com.cn',
      storeUrl: 'https://store.sgsonline.com.cn',
      mallUrl: 'https://gray.sgsmall.com.cn',
      javaUrl: 'https://gate.sgsonline.com.cn',
      domain: '.sgsonline.com.cn',
      version: 'gray',
      indUrl: 'https://ind.sgsonline.com',
      memberUrl: 'https://membergray.sgsonline.com.cn',
      indMemberUrl: 'https://indgray.sgsonline.com.cn/'
    },
  ]
  return hostList.find(v => v.env === env)
}

export {
  host
}